export default __webpack_public_path__ + "static/media/pdf-icon.3e5fcf7d.svg";